import type {v4} from 'uuid'

export type RumSettings = Ya.Rum.LogErrorSettings & Ya.Rum.RUMSettings

export type RumKnownApps = 'account' | 'route' | 'order'

export type RumServerConfig = Required<Pick<RumSettings, 'clck' | 'env' | 'version' | 'page' | 'region'>> & {
  reqid: ReturnType<typeof v4>
  uid: RumSettings['yandexuid']
  platform: Extract<RumSettings['platform'], 'desktop' | 'touch'>
}

export type RumMiddlewareOutput = {
  config: RumServerConfig
  bundleSrc?: string
  inlineJs: {
    rumCounter: string
    errorCounter: string
    mfpObserver?: string
  }
}

export enum RumTimeMark {
  BEFORE_JS_FRAMEWORK_INIT = '3070',
  JS_FRAMEWORK_INITED = '3036',
  REACT_INITED = 'react.inited',
}
